import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/how-to-play')({
    component: HowToPlayPage,
})

function HowToPlayPage() {
    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-6">How to Play BlockPot</h1>
            <div className="prose dark:prose-invert max-w-none">
                <p>Learn how to play BlockPot and maximize your chances of winning!</p>
                {/* Add your how-to-play content here */}
            </div>
        </div>
    )
}